<template>
  <b-form @submit="onSubmit">
    <b-col lg="10" class="col-content">
      <h1>{{ $t('privatePage.expert_report_edit_translations') }}</h1>
      <b-tabs ref="tabs">
        <b-tab v-for="(translation, translationIndex) in currentReport.translations" :key="translationIndex" :title="getLangName(translation.languageId)">

          <b-form-group style="margin-top: 20px;">
            <b-button @click="onOpenEditTitleDialog(translationIndex)" class="buttonGroup me-1" type="button" variant="primary">{{ $t('privatePage.expert_report_new_header') }}</b-button>
            <b-button v-if="false" class="buttonGroup me-1" type="button" variant="primary">{{ $t('privatePage.expert_report_new_subheader') }}</b-button>
            <b-button @click="onOpenEditTextDialog(translationIndex)" class="me-1" type="button" variant="primary">{{ $t('privatePage.expert_report_new_text_with_terms') }}</b-button>
            <b-button class="buttonGroup me-1" type="submit" variant="primary">{{ $t('save') }}</b-button>
            <b-button @click="onLaunchPreview(translationIndex)" class="buttonGroup me-1" type="button" variant="primary">{{ $t('preview') }}</b-button>
            <b-button @click="onOpenInfoModal()" style="width: 36px;" type="button" class="fa fa-info buttonGroup me-1" variant="warning"></b-button>
          </b-form-group>
           <b-form-group id="translationName">
             <h2 class="inputHeader">{{ $t('privatePage.expert_pdf_report_name_header') }}</h2>
            <b-form-input id="translatedNameInput"
                        type="text"
                        v-model="translation.translatedName" style="width:384px;">
            </b-form-input>
          </b-form-group>
           <b-form-group id="translationSubtitle">
             <h2 class="inputHeader">{{ $t('privatePage.expert_pdf_report_subtitle') }}</h2>
            <b-form-input id="translatedSubtitleInput"
                        type="text"
                        v-model="translation.translatedSubtitle" style="width:384px;">
            </b-form-input>
          </b-form-group>
          <draggable v-model="translation.items" item-key="title">
            <template #item="{element, index}">
              <div>
                <b-card no-body class="mb-1">
                  <b-card-header style="padding:10px;cursor:pointer;" header-tag="header" class="p-1" role="tab" v-b-toggle="'accordion' + index">
                    <h2>
                      {{element.title}}
                    </h2>
                  </b-card-header>
                  <b-collapse :id="'accordion' + index" role="tabpanel">
                    <b-card-body>
                      <b-row>
                        <b-col>
                        <b-button style="margin-bottom:10px;" variant="info" @click="onOpenEditTitleDialog(translationIndex, element)">{{ $t('privatePage.expert_report_edit_title') }}</b-button>
                        <draggable v-model="element.items" item-key="title">
                          <template #item="{element: item}">
                            <div>
                              <b-card style="cursor:pointer;" @click="onOpenEditTextDialog(translationIndex, item)" >
                                {{item.title}}
                              </b-card>
                            </div>
                          </template>
                        </draggable>
                        </b-col>
                      </b-row>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>
            </template>
          </draggable>
        </b-tab>
      </b-tabs>
    </b-col>

    <b-modal id="infomodal" title="Information" v-model="showInfoModal">
        <h2 class="my-4">{{ $t('privatePage.expert_report_formulas') }}</h2>
        <b-row>
        <b-col lg="2">
            <p>{{ $t('privatePage.expert_report_formulas_and_operator') }}</p>
            <p>{{ $t('privatePage.expert_report_formulas_or_operator') }}</p>
            <p>{{ $t('privatePage.expert_report_formulas_gt_operator') }}</p>
            <p>{{ $t('privatePage.expert_report_formulas_lt_operator') }}</p>
            <p>{{ $t('privatePage.expert_report_formulas_eq_operator') }}</p>
            <p>{{ $t('privatePage.expert_report_formulas_gteq_operator') }}</p>
            <p>{{ $t('privatePage.expert_report_formulas_lteq_operator') }}</p>
        </b-col>
        <b-col>
            <p>{{ $t('privatePage.expert_report_formulas_and') }}</p>
            <p>{{ $t('privatePage.expert_report_formulas_or') }}</p>
            <p>{{ $t('privatePage.expert_report_formulas_gt') }}</p>
            <p>{{ $t('privatePage.expert_report_formulas_lt') }}</p>
            <p>{{ $t('privatePage.expert_report_formulas_eq') }}</p>
            <p>{{ $t('privatePage.expert_report_formulas_gteq') }}</p>
            <p>{{ $t('privatePage.expert_report_formulas_lteq') }}</p>
        </b-col>
        </b-row>
        <b-row>
          <b-col>
            {{$t('privatePage.expert_report_formulas_example')}}
          </b-col>
        </b-row>

        <h2 class="my-4">{{$t('privatePage.expert_report_formatting')}}</h2>
        <b-row>
          <b-col>
            <span>
              {{$t('privatePage.expert_report_formatting_12_BOL_start')}}
            </span>
            <span style="font-weight: bold;">
              {{$t('privatePage.expert_report_formatting_12_BOL_example')}}
            </span>
            <span>
              {{$t('privatePage.expert_report_formatting_end')}}
            </span>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <span>
              {{$t('privatePage.expert_report_formatting_12_BOL_UL_ITA_start')}}
            </span>
            <span style="font-weight: bold; text-decoration: underline; font-style: italic">
              {{$t('privatePage.expert_report_formatting_12_BOL_UL_ITA_example')}}
            </span>
            <span>
              {{$t('privatePage.expert_report_formatting_end')}}
            </span>
          </b-col>
        </b-row>
        <template #footer>
          <div class="pull-right">
            <b-button variant="primary" @click="onCloseInfoModal()">Ok</b-button>
          </div>
        </template>
    </b-modal>

    <b-modal ref="editorModal" v-model="showEditorModal" id="editorModal" size="lg" no-close-on-backdrop hide-footer>
      <template #title>
        <h1 class="modalHeader">{{$t('privatePage.expert_report_edit_item_header')}}</h1>
      </template>
      <expert-report-item-editor :currentItem="currentItem"
                              :editorType="editorType"
                              :allTitles="allTitles"
                              :conditions="currentAvailableConditions"
                              :isOpened="isOpened"
                              v-on:onTitleUpdated="onTitleUpdated"
                              v-on:onTextUpdated="onTextUpdated"
                              v-on:formCancelled="formCancelled"
                              v-on:titleDeleted="titleDeleted"
                              v-on:textDeleted="textDeleted" />
    </b-modal>
  </b-form>
  </template>

<script>
import miscFuncs from '../../js/helpers/misc'
import draggable from 'vuedraggable'
import ExpertReportItemEditor from '../../components/expertreports/expertreportitemeditor'

export default {
  name: 'expert-report-content-editor',
  components: {
    draggable,
    ExpertReportItemEditor
  },
  data() {
    return {
      currentTranslationIndex: 0,
      currentAvailableConditions: '',
      currentItem: {},
      editorType: '',
      allTitles: [],
      isOpened: false,
      showEditorModal: false,
      showInfoModal: false
    }
  },
  props: {
    currentReport: {},
    languages: {}
  },
  methods: {
    getLangName: function(languageId) {
      return miscFuncs.getLangName(languageId, this.languages)
    },
    onOpenInfoModal: function() {
      this.showInfoModal = true
    },
    onCloseInfoModal: function() {
      this.showInfoModal = false
    },
    onOpenEditTitleDialog: function(translationIndex, title) {
      this.currentTranslationIndex = translationIndex
      this.currentItem = {}
      this.editorType = 'title'

      if (title !== undefined && title !== null) {
        this.currentItem = title
      }

      this.isOpened = true
      this.showEditorModal = true
    },
    onTranslationUpdated: function(translation) {
      this.$emit('onSubmit', this.currentReport)
    },
    onOpenEditTextDialog: function(translationIndex, text) {
      this.currentItem = {}
      this.currentTranslationIndex = translationIndex

      // eslint-disable-next-line
      this.currentAvailableConditions = this.currentReport.translations[
        translationIndex
      ].availableConditions
      this.editorType = 'text'

      if (text !== undefined && text !== null) {
        this.currentItem = text
      }

      for (
        let i = 0;
        i <
        // eslint-disable-next-line
        this.currentReport.translations[this.currentTranslationIndex].items
          .length;
        i++
      ) {
        // eslint-disable-next-line
        let title = this.currentReport.translations[
          this.currentTranslationIndex
        ].items[i]
        this.allTitles[i] = {
          value: title.id,
          text: title.title
        }
      }

      this.isOpened = true
      this.showEditorModal = true
    },
    onSubmit: function(evt) {
      evt.preventDefault()
      this.$emit('onSubmit', this.currentReport)
    },
    onTitleUpdated: function(title) {
      let isExisting =
        title.id !== undefined && title.id !== null && title.id !== ''

      if (!isExisting) {
        title.id = this.$uuid.v4()
        title.index = -1
        title.items = []
        title.type = 'title'
        title.condition = ''
        title.parent = ''
        title.belongsto = ''

        // eslint-disable-next-line
        this.currentReport.translations[
          this.currentTranslationIndex
        ].items.push(title)
      }

      this.isOpened = false
      this.showEditorModal = false
    },
    onTextUpdated: function(text) {
      let isExisting =
        text.id !== undefined && text.id !== null && text.id !== ''

      if (!isExisting) {
        text.id = this.$uuid.v4()
        text.index = -1
        text.items = []
        text.type = 'text'
        text.parent = ''

        // eslint-disable-next-line
        this.currentReport.translations[this.currentTranslationIndex].items
          .find(title => title.id === text.belongsto)
          .items.push(text)
      }

      this.isOpened = false
      this.showEditorModal = false
    },
    titleDeleted: function(title) {
      // eslint-disable-next-line
      this.currentReport.translations[
        this.currentTranslationIndex
      ].items.splice(
        this.currentReport.translations[this.currentTranslationIndex].items
          .map(t => t.id)
          .indexOf(title.id),
        1
      )

      this.isOpened = false
      this.showEditorModal = false
    },
    textDeleted: function(text) {
      // eslint-disable-next-line
      this.currentReport.translations[this.currentTranslationIndex].items
        .find(title => title.id === text.belongsto)
        .items.splice(
          this.currentReport.translations[this.currentTranslationIndex].items
            .find(title => title.id === text.belongsto)
            .items.map(i => i.id)
            .indexOf(text.id),
          1
        )

      this.isOpened = false
      this.showEditorModal = false
    },
    formCancelled: function() {
      this.isOpened = false
      this.showEditorModal = false
    },
    onLaunchPreview(translationIndex) {
      this.currentTranslationIndex = translationIndex

      this.$emit('onGeneratePdf', {
        testId: this.currentReport.testMethodId,
        reportId: this.currentReport.id,
        normGroupId: '',
        // eslint-disable-next-line
        languageId: this.currentReport.translations[
          this.currentTranslationIndex
        ].languageId
      })
    }
  }
}
</script>
<style>
.cardContent .list-group-item:hover {
  background-color: #1bc2f3 !important;
  color: #fff !important;
  cursor: pointer;
}
.buttonGroup {
  height: 36px;
}
.contentItem {
  margin: 10px !important;
}
.inputHeader {
  margin-top: 20px;
}
</style>
